import { useMemo } from "react";
import { useTheme } from "@/lib/theme";

/** Resolved hex palettes for contexts that cannot use CSS variables —
 * WebGL (three.js), Cytoscape and canvas exports all need real colour values. */
export const PALETTES = {
    gold: {
        accent: "#FDE047",      // bright gold — highlights, primary series
        brand: "#D4AF37",       // brand gold — structure, secondary series
        danger: "#EF4444",
        warn: "#F97316",
        safe: "#10B981",
        neutral: "#B8A47C",
        baseCool: "#2A2113",     // dark brass body for 3D solids
        rimSecondary: "#C9962B", // brass — secondary key light
        canvas: "#050505",
    },
    cyber: {
        accent: "#00F0FF",
        brand: "#0044FF",
        danger: "#FF0044",
        warn: "#FF832B",
        safe: "#00F0FF",
        neutral: "#C0C0C7",
        baseCool: "#0B1B3A",
        rimSecondary: "#FF0044",
        canvas: "#05050A",
    },
    galactic: {
        accent: "#C4B5FD",
        brand: "#7C3AED",
        danger: "#F43F5E",
        warn: "#FBBF24",
        safe: "#34D399",
        neutral: "#A7A3C7",
        baseCool: "#1C1642",
        rimSecondary: "#EC4899",
        canvas: "#060418",
    },
    liquid: {
        accent: "#7DD3FC",
        brand: "#818CF8",
        danger: "#FB7185",
        warn: "#FBBF24",
        safe: "#6EE7B7",
        neutral: "#CBD5E1",
        baseCool: "#1B2440",
        rimSecondary: "#F472B6",
        canvas: "#0A0E1F",
    },
    brutal: {
        accent: "#4ADE80",
        brand: "#22C55E",
        danger: "#FF1744",
        warn: "#FACC15",
        safe: "#4ADE80",
        neutral: "#9CA3AF",
        baseCool: "#0A0A0A",
        rimSecondary: "#E5E7EB",
        canvas: "#000000",
    },
    command: {
        accent: "#FB923C",
        brand: "#60A5FA",
        danger: "#EF4444",
        warn: "#FACC15",
        safe: "#34D399",
        neutral: "#94A3B8",
        baseCool: "#1E2532",
        rimSecondary: "#EF4444",
        canvas: "#0A0C12",
    },
};

export function usePalette() {
    const { theme } = useTheme();
    return useMemo(() => PALETTES[theme] || PALETTES.gold, [theme]);
}
